<template>
    <div class="extra-fields"
         style="display: flex; gap: 15px; align-items: center">
        <el-checkbox v-model="checkbox"
                     class="custom-checkbox"
                     @change="emitChange">
            Автосогласование
            <el-tooltip placement="top">
                <div slot="content">
                    Для выбранного согласующего будет произведено автоматическое согласование рабочей документации в указанную дату
                </div>
                <i class="el-icon-question" />
            </el-tooltip>
        </el-checkbox>
        <el-date-picker
            v-if="checkbox"
            v-model="date"
            style="width: 8rem"
            type="date"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            placeholder="Выберите дату"
            size="mini"
            :picker-options="{ disabledDate }"
            @change="emitChange" />
    </div>
</template>

<script>
export default {
  name: 'UserFieldAutoApproveExtra',
  props: {
    checkboxValue: { type: Boolean, default: false },
    dateValue: { type: [String, Date], default: null }
  },
  data() {
    return {
      checkbox: this.checkboxValue,
      date: this.dateValue
    }
  },
  watch: {
    checkboxValue(val) {
      this.checkbox = val
    },
    dateValue(val) {
      this.date = val
    }
  },
  methods: {
    emitChange() {
      if (this.checkbox && !this.date) {
        const today = new Date()
        const twoDaysLater = new Date(today)
        twoDaysLater.setDate(today.getDate() + 2)
        this.date = twoDaysLater.toISOString().split('T')[0]
      }
      
      this.$emit('extra-fields-change', {
        checkbox: this.checkbox,
        date: this.date
      })
    },
    disabledDate(date) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return date.getTime() < today.getTime()
    },
    validate() {
      if (this.checkbox && !this.date) {
        this.$notify({
          type: 'warning',
          title: 'Ошибка валидации',
          message: 'Необходимо указать дату автосогласования'
        });
        return false;
      }
      return true;
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.custom-checkbox) {
.el-checkbox__label {
  margin-top: 6.5px;
  margin-bottom: 6.5px;
}
.el-checkbox__inner {
  width: 16px;
  height: 16px;
}

.el-icon-question {
  margin-left: 4px;
  color: #909399;
  cursor: help;
}
}
:deep(.custom-checkbox.is-checked) {
.el-checkbox__label {
  color: #606266 !important;
}
}
</style> 